import type { ICustomControlSupervisionReadProps } from '../../interfaces';
import { translateKey } from '../../../../../translate';
import { FormGroupRead } from '../../utils/v1/FormGroupRead';

export function TcohV2SupervisionBiometricsSummary(props: ICustomControlSupervisionReadProps) {
    return (
        <FormGroupRead
            label={translateKey('supervision.qualityCheck')}
            value={
                props.supervision.assessmentBiometrics
                    ? translateKey(`supervisorsAssessmentBiometricsEnum.${props.supervision.assessmentBiometrics}`)
                    : '-'
            }
        />
    );
}
